<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("RESTRICTION_INFOMATION") }}</h4>
    </div>
    <div class="grid-body p-3 border-top-unset">
      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
      <v-form ref="form" lazy-validation v-on:submit.prevent v-if="editedItem">
        <v-row>
          <v-col sm="12" class="pt-0 pb-0">
            <label>{{ $t("RESTRICTION_NAME") }} *</label>
            <v-text-field
              v-model="editedItem.nameVi"
              :rules="ruleNotEmpty"
              v-on:keyup="updateRestrictionTitle(editedItem.nameVi)"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-tabs v-model="tab" class="pl-0">
          <v-tab>{{ $t("VIETNAMESE") }}</v-tab>
          <v-tab>{{ $t("ENGLISH") }}</v-tab>
        </v-tabs>
        <v-row
          v-if="
            editedItem.restrictionPlanI18n &&
              editedItem.restrictionPlanI18n.find(x => x.lang == langTab)
          "
        >
          <v-col sm="12" class="pb-0">
            <label>{{ $t("RESTRICTION_NAME") }} *</label>
            <v-text-field
              v-model="
                editedItem.restrictionPlanI18n.find(x => x.lang == langTab).name
              "
              outlined
              dense
              :rules="ruleNotEmpty"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-col sm="12" class="pb-0">
          <v-checkbox
            color="indigo darken-3"
            :label="$t('ACTIVATE')"
            v-model="editedItem.status"
          ></v-checkbox>
        </v-col>
        <div class="text-right">
          <v-btn class="mr-5" depressed @click="back">
            {{ $t("BACK") }}
          </v-btn>
          <v-btn color="primary" class="pr-10 pl-10" @click="save">{{ $t("SAVE") }}</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
<script>
import { restriction } from "@/_services/SaleRoom/restriction.js";
import { _alert } from "@/_helpers/function.js";
export default {
  components: {},
  data() {
    return {
      systemLang: this.$i18n.locale,
      editedItem: {
        belongTo: null,
        nameVi: "",
        externalCode: null,
        id: null,
        restrictionPlanI18n: [
          {
            lang: "vi",
            name: "",
            description: ""
          },
          {
            lang: "en",
            name: "",
            description: ""
          }
        ],
        sortIndex: 0,
        status: true,
        uneditable: false
      },
      langTab: "vi",
      tab: null,
      ruleNotEmpty: [v => !!v || this.$t("NOT_EMPTY")],
      isLoading: false,
      isEmptyDefaultTitle: false
    };
  },
  created() {
    this.initialize();
  },
  watch: {
    tab(value) {
      this.langTab = value ? "en" : "vi";
    }
  },
  methods: {
    async initialize() {
      let id = this.$route.params.id;
      if (id != "00000000-0000-0000-0000-000000000000") {
        this.isLoading = true;
        await restriction.detailPackageRestriction(id).then(res => {
          if (res.responseCode == 0) {
            this.editedItem = res.data;
          }
        }).finally(() => (this.isLoading = false));
      }
    },
    save() {
      let form_validate = this.$refs.form.validate();
      let id = this.$route.params.id;

      if (!form_validate) {
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false
        });
        const el = document.querySelector(
          ".v-messages.error--text:first-of-type"
        );
        el.scrollIntoView();
        return false;
      }

      if (id != "00000000-0000-0000-0000-000000000000") {
        restriction.updatePackageRestriction(this.editedItem).then(res => {
          _alert(res, this.$t(res.data), false);
        });
        let vm = this;
        setTimeout(function() {
          vm.$router.push({ name: "listPackageRestriction" });
        }, 1000);
      } else {
        restriction.createPackageRestriction(this.editedItem).then(res => {
          _alert(res, this.$t(res.data), false);
        });
        let vm = this;
        setTimeout(function() {
          vm.$router.push({ name: "listPackageRestriction" });
        }, 1000);
      }
    },
    updateRestrictionTitle(value) {
      if (value.length > 0) {
        this.isEmptyDefaultTitle = false;
        for (let i = 0; i < this.editedItem.restrictionPlanI18n.length; i++) {
          this.editedItem.restrictionPlanI18n[i].name = value;
        }
      } else {
        this.isEmptyDefaultTitle = true;
      }
    },
    back() {
      this.$router.push({ name: "listPackageRestriction" });
    }
  }
};
</script>
